import { render, staticRenderFns } from "./table-widget.vue?vue&type=template&id=81e93904&scoped=true&"
import script from "./table-widget.vue?vue&type=script&lang=js&"
export * from "./table-widget.vue?vue&type=script&lang=js&"
import style0 from "./table-widget.vue?vue&type=style&index=0&id=81e93904&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e93904",
  null
  
)

export default component.exports